import React, {useState, useEffect, useRef} from "react";
import axios from "axios";
import "./App.css";

function App() {
  const [message, setMessage] = useState("");
  const [history, setHistory] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const bottomRef = useRef(null);

  useEffect(() => {
    if (bottomRef.current) {
      bottomRef.current.scrollIntoView({behavior: "smooth"});
    }
  }, [history, isLoading]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!message.trim() || isLoading) return;

    const userMessage = {sender: "user", text: message};
    setHistory((prev) => [...prev, userMessage]);
    setMessage("");
    setIsLoading(true);

    try {
      const response = await axios.post(
        "https://b05un-school-rag-api.hf.space/rag-query",
        {
          message: message,
          history: JSON.stringify(
            history.map((msg) => ({
              role: msg.sender,
              content: msg.text,
            }))
          ),
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const botMessage = {sender: "bot", text: response.data.response};
      setHistory((prev) => [...prev, botMessage]);
    } catch (error) {
      console.error("Error calling API:", error);
      const errorMessage = {
        sender: "bot",
        text: "Sorry, I encountered an error. Please try again.",
      };
      setHistory((prev) => [...prev, errorMessage]);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="app">
      <header className="app-header">
        <img
          src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRxyqlTZu2NWbd3PYbASeEU1m6kwJ8I7Iysl2I24QhdEGC4JdpAdC78zngc4qTABiaYmiSLpJZ12l0QJivIsf9dvW9noDaXkDHkDYStcA"
          alt="FUOYE Logo"
          className="school-logo"
        />
        <h1>FUOYE Chatbot</h1>
        <p className="subtitle">Ask anything about the university</p>
      </header>

      <div className="chat-container">
        <div className="messages">
          {history.map((msg, index) => (
            <div key={index} className={`message ${msg.sender}`}>
              {msg.text}
            </div>
          ))}
          {isLoading && <div className="message bot">Thinking...</div>}
          <div ref={bottomRef} />
        </div>

        <form onSubmit={handleSubmit} className="message-form">
          <input
            type="text"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Type your question here..."
            disabled={isLoading}
          />
          <button type="submit" disabled={isLoading}>
            {isLoading ? "Sending..." : "Send"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default App;
